import {
    HiOutlineQuestionMarkCircle,
    HiOutlineFolderDownload,
    HiOutlineClipboardList,
    HiOutlineClipboardCheck,
    HiOutlineCog,
    HiOutlineClock,
    HiOutlineCalendar,
    HiOutlineDocumentText,
    HiOutlineDesktopComputer,
    HiOutlineUsers,
    HiOutlineUserGroup,
    HiOutlineShieldCheck,
    HiOutlineKey,
    HiOutlineBriefcase,
    HiOutlineDatabase,
    HiOutlineCube,
    HiOutlineTag
} from 'react-icons/hi'

export const DASHBOARD_SIDEBAR_LINKS = [
    {
        key: 'attendance',
        label: 'Attendance',
        roles: ['super admin', 'employee', 'finance', 'management'], // Roles that can see this category
        links: [
            {
                key: 'clockInOut',
                label: 'Clock In/Out',
                path: '/',
                icon: <HiOutlineClock />,
                roles: ['super admin', 'user']
            },
            {
                key: 'ot',
                label: 'OT',
                path: '/attendance/ot',
                icon: <HiOutlineClipboardCheck />,
                roles: ['super admin', 'user']
            },
            {
                key: 'applyLeave',
                label: 'Leave',
                path: '/attendance/leave',
                icon: <HiOutlineCalendar />,
                roles: ['super admin', 'user']
            },
            {
                key: 'dtr',
                label: 'DTR',
                path: '/attendance/dtr',
                icon: <HiOutlineDocumentText />,
                roles: ['super admin', 'user']
            }
        ]
    },

    {
        key: 'deviceAssignment',
        label: 'Device',
        roles: ['super admin', 'employee', 'finance', 'management'], // Roles that can see this category
        links: [
            {
                key: 'deviceAssignment',
                label: 'Device Assignment',
                path: 'inventory/employee/assigned-items',
                icon: <HiOutlineDesktopComputer />,
                roles: ['super admin', 'employee', 'finance', 'management']
            }
        ]
    },
    {
        key: 'finance',
        label: 'Finance',
        roles: ['finance'],
        links: [
            {
                key: 'generateDTR',
                label: 'Generate DTR',
                path: '/finance/generate-dtr',
                icon: <HiOutlineFolderDownload />,
                roles: ['super admin']
            },
            {
                key: 'employees',
                label: 'Employee Records',
                path: '/employee',
                icon: <HiOutlineUsers />,
                roles: ['super admin']
            },
            {
                key: 'leaveApproval',
                label: 'Leave Request',
                path: '/leave/leave-approval',
                icon: <HiOutlineClipboardList />,
                roles: ['management']
            },
            {
                key: 'leaveApproval',
                label: 'Leave Schedule',
                path: '/leave/leave-approved',
                icon: <HiOutlineCalendar />,
                roles: ['management']
            }
        ]
    },
    {
        key: 'management',
        label: 'Management',
        roles: ['management'],
        links: [
            {
                key: 'employees',
                label: 'Employee Records',
                path: '/employee',
                icon: <HiOutlineUsers />,
                roles: ['super admin', 'management']
            },
            {
                key: 'generateDTR',
                label: 'Overtime Approval',
                path: '/management/overtime-approval',
                icon: <HiOutlineClipboardCheck />,
                roles: ['management']
            },
            {
                key: 'leaveApproval',
                label: 'Leave Request',
                path: '/leave/leave-approval',
                icon: <HiOutlineClipboardList />,
                roles: ['management']
            },
            {
                key: 'leaveApproval',
                label: 'Leave Schedule',
                path: '/leave/leave-approved',
                icon: <HiOutlineCalendar />,
                roles: ['management']
            },
            {
                key: 'employeesLeave',
                label: 'Employees Leave',
                path: '/leave/employee/list',
                icon: <HiOutlineUserGroup />,
                roles: ['management']
            }
        ]
    },
    {
        key: 'superadmin',
        label: 'Super Admin',
        roles: ['super admin'],
        links: [
            {
                key: 'roles',
                label: 'Roles',
                path: '/roles',
                icon: <HiOutlineShieldCheck />,
                roles: ['super admin']
            },
            {
                key: 'employees',
                label: 'Employee Records',
                path: '/employee',
                icon: <HiOutlineUsers />,
                roles: ['super admin', 'management']
            },
            {
                key: 'employees',
                label: 'Accounts',
                path: '/user-account',
                icon: <HiOutlineKey />,
                roles: ['super admin']
            },
            {
                key: 'employeesLeave',
                label: 'Employees Leave',
                path: '/leave/employee/list',
                icon: <HiOutlineUserGroup />,
                roles: ['management']
            },
            // {
            //     key: 'leaveApproval',
            //     label: 'Leave Approval',
            //     path: '/leave/leave-approval',
            //     icon: <HiOutlineClipboardList />,
            //     roles: ['management']
            // },
            {
                key: 'positions',
                label: 'Position',
                path: '/positions',
                icon: <HiOutlineBriefcase />,
                roles: ['super admin']
            },
            {
                key: 'audit-trail',
                label: 'Audit Trail',
                path: '/audit-trail',
                icon: <HiOutlineDatabase />,
                roles: ['super admin']
            }
        ]
    },
    {
        key: 'inventory',
        label: 'Inventory',
        roles: ['super admin'],
        links: [
            {
                key: 'inventory',
                label: 'Item List',
                path: '/inventory/items',
                icon: <HiOutlineCube />,
                roles: ['super admin']
            },
            {
                key: 'categories',
                label: 'Categories',
                path: '/categories/items',
                icon: <HiOutlineTag />,
                roles: ['super admin']
            },
            {
                key: 'inventory',
                label: 'Employee Items',
                path: '/inventory/assigned-items',
                icon: <HiOutlineUserGroup />,
                roles: ['super admin']
            },
            {
                key: 'inventory',
                label: 'Assign Item',
                path: '/inventory/assign-item',
                icon: <HiOutlineClipboardCheck />,
                roles: ['super admin']
            }
        ]
    },
    {
        key: 'kiosk',
        label: 'Kiosk',
        roles: ['super admin'],
        links: [
            {
                key: 'kiosks',
                label: 'Kiosks',
                path: '/kiosks',
                icon: <HiOutlineDesktopComputer />,
                roles: ['super admin']
            }
        ]
    }
]

export const DASHBOARD_SIDEBAR_BOTTOM_LINKS = [
    {
        key: 'settings',
        label: 'Settings',
        path: '/settings',
        icon: <HiOutlineCog />
    },
    {
        key: 'support',
        label: 'Help & Support',
        path: '/support',
        icon: <HiOutlineQuestionMarkCircle />
    }
]
